// extracted by mini-css-extract-plugin
module.exports = {"editorWrapper":"TermsEditModal_editorWrapper__3ZBB7"};